import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesome } from '../FontAwesome';

export const Spinner = (props) => {
  const { className, label } = props;

  return (
    <span className={className} aria-busy="true">
      <FontAwesome name="circle-o-notch" spin />
      {label ? ` ${label}` : null}
    </span>
  );
};

Spinner.propTypes = {
  className: PropTypes.string,
  label: PropTypes.string,
};

Spinner.defaultProps = {
  className: null,
  label: '',
};
